import { render } from "./FormGridMember.vue?vue&type=template&id=1529bc9d&ts=true"
import script from "./FormGridMember.ts?vue&type=script&lang=ts&external"
export * from "./FormGridMember.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__